// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__3iK4t","box":"WorkspacesBox_box__3qQ9_","node":"WorkspacesBox_node__2RDYo"};